import {getRequest, URL_SERVER} from './../requests'


export async function getMyCompany(token){
    try {
        return await getRequest(URL_SERVER + '/mycompany', token)
    } catch (error) {
        console.error(error);
    }
}